import React, { FC, ReactNode, useState } from 'react';
import { GetStartedContext } from './context';

const GetStartedProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [infoIsComplete, setInfoIsComplete] = useState(false);
  return (
    <GetStartedContext.Provider
      value={{
        infoIsComplete,
        setInfoIsComplete
      }}>
      {children}
    </GetStartedContext.Provider>
  );
};

export default GetStartedProvider;
